import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

import {
  getShouldHideExploreCollectionModal,
  setShouldHideExploreCollectionModal,
} from '../../utils/collectionEducation';

import {
  trackViewedCollectionEducation,
  trackDismissedCollectionEducation,
  trackTappedCollectionEducationExplored,
} from '../../actions/tracking/home';

import { setHomeFulfillmentMethod } from '../../actions/homeFeedActions';

import { FULFILLMENT_METHOD_COLLECTION } from '../../utils/constants';

import { getHasMultipleFulfillmentMethods } from '../../selectors/homeSelectors';
import { isFeatureActive } from '../../selectors/configSelectors';
import { CO_CLICK_AND_COLLECT } from '../../flags/features';

const ExploreCollectionModal = dynamic(import('../../components/ExploreCollectionModal'), {
  ssr: false,
});

export class ExploreCollectionModalContainer extends Component {
  state = {
    isOpen: false,
  };

  closeModal = () => {
    this.setState({
      isOpen: false,
    });

    setShouldHideExploreCollectionModal();
  };

  onClose = () => {
    this.closeModal();
    this.props.trackDismissedCollectionEducation();
  };

  onExploreCollection = () => {
    this.closeModal();
    this.props.setHomeFulfillmentCollection();
    this.props.trackTappedCollectionEducationExplored();
  };

  componentDidMount() {
    const isOpen =
      this.props.withClickAndCollect &&
      this.props.showEducationModal &&
      !getShouldHideExploreCollectionModal();

    if (isOpen) {
      this.setState({
        isOpen: true,
      });

      this.props.trackViewedCollectionEducation();
    }
  }

  render() {
    return (
      this.props.withClickAndCollect &&
      this.props.showEducationModal && (
        <ExploreCollectionModal
          appElement={this.props.appElement}
          isOpen={this.state.isOpen}
          onExploreCollection={this.onExploreCollection}
          onClose={this.onClose}
        />
      )
    );
  }
}

ExploreCollectionModalContainer.defaultProps = {
  appElement: '#__next',
  showEducationModal: false,
  withClickAndCollect: false,
  setHomeFulfillmentCollection: () => {},
  trackViewedCollectionEducation: () => {},
  trackDismissedCollectionEducation: () => {},
  trackTappedCollectionEducationExplored: () => {},
};

ExploreCollectionModalContainer.propTypes = {
  appElement: PropTypes.string,
  showEducationModal: PropTypes.bool,
  withClickAndCollect: PropTypes.bool,
  setHomeFulfillmentCollection: PropTypes.func,
  trackViewedCollectionEducation: PropTypes.func,
  trackDismissedCollectionEducation: PropTypes.func,
  trackTappedCollectionEducationExplored: PropTypes.func,
};

export const mapStateToProps = (state) => ({
  showEducationModal: getHasMultipleFulfillmentMethods(state),
  withClickAndCollect: isFeatureActive(state, CO_CLICK_AND_COLLECT),
});

const mapDispatchToProps = (dispatch) => ({
  setHomeFulfillmentCollection: () =>
    dispatch(setHomeFulfillmentMethod({ fulfillmentMethod: FULFILLMENT_METHOD_COLLECTION })),
  trackViewedCollectionEducation: () => dispatch(trackViewedCollectionEducation()),
  trackDismissedCollectionEducation: () => dispatch(trackDismissedCollectionEducation()),
  trackTappedCollectionEducationExplored: () => dispatch(trackTappedCollectionEducationExplored()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExploreCollectionModalContainer);
